export default {
  enterName: '请输入名称',
  selectDevice: '请选择设备',
  enterDescription: '请输入描述',
  addSuccess: '新增成功',
  deleteSuccess: '删除成功',
  addDevice: '新增版本',
  deviceName: '名称或版本',
  deleteDeviceConfirm: '删除本条设备?',
  delete: '删除',
  name: '名称',
  deviceID: '设备ID',
  deviceType: '设备类型',
  latestLaunchDate: '最近一次上线时间',
  deviceEmpower: '设备授权',
  state: '状态',
  description: '描述',
  action: '操作',
  deviceSN: '设备SN',
  select: '请选择',
  deviceIDPlaceholder: '设备ID',
  descriptionPlaceholder: '描述',
  version: '版本',
}
